import { Form, Input } from "antd";
import React from "react";
import { edCompField } from "../ParamsEditorInfo2";
import { Addon } from "./common";

export const MaskedInputEdProps: React.FC = () => (
  <>
    <Form.Item
      name={edCompField("mask")}
      label="Маска"
      rules={[{ required: true }]}
      tooltip={
        <a
          href="https://imask.js.org/guide.html#masked-pattern"
          target="_blank"
          rel="noreferrer"
        >
          Подробное описание правил
        </a>
      }
    >
      <Input allowClear />
    </Form.Item>
    <Addon />
  </>
);
